import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import React from 'react'

import { createStyles, TableCell, Theme } from '@mui/material'
import { WithStyles, withStyles } from '@mui/styles'

const Cell: React.SFC<CellProps & WithStyles<typeof styles>> = ({
  classes,
  style,
  className,
  children,
  decoration,
  tooltip,
  centered = false,
  colSpan = 1,
  onClick,
}) => {
  return (
    <TableCell
      className={classNames(className, classes.cell, onClick ? classes.clickable : undefined)}
      size="small"
      colSpan={colSpan}
      style={style}
      onClick={onClick}
    >
      <div className={classNames(classes.verticallyCentered, centered ? classes.horizontallyCentered : undefined)}>
        {decoration}
        <BaseTooltip title={tooltip}>
          <div className={classes.childrenContainer}>{children}</div>
        </BaseTooltip>
      </div>
    </TableCell>
  )
}

export type CellProps = {
  style?: React.CSSProperties
  className?: string
  extraDense?: boolean
  tooltip?: string
  children: React.ReactNode
  decoration?: React.ReactNode
  centered?: boolean
  colSpan?: number
  onClick?: () => any
}

export const styles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    cell: {
      position: 'relative',
      [breakpoints.down('sm')]: {
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
      },
    },
    clickable: {
      cursor: 'pointer',
    },
    verticallyCentered: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    horizontallyCentered: {
      justifyContent: 'center',
    },
    childrenContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      width: '100%',
    },
  })

export default withStyles(styles)(Cell)
